import { Arcade } from '../../api';
export const TokenState = Arcade.TokenState;